// FormInput.tsx
const FormInput = ({
  value,
  onChange,
  readOnly,
}: {
  value: string | number;
  onChange?: (val: string) => void;
  readOnly: boolean;
}) => (
  <input
    value={value}
    readOnly={readOnly}
    onChange={(e) => onChange?.(e.target.value)}
    className={`
      w-full h-[38px] rounded-lg border px-3
      text-sm font-semibold
      ${
        readOnly
          ? "bg-gray-50 text-gray-400 cursor-not-allowed"
          : "bg-white text-gray-900 focus:ring-1 focus:ring-black"
      }
    `}
  />
);

export default FormInput;
